<form
  method="POST"
  action="{{ requestJSON?.checkoutUrl }}"
  id="cardlinkForm"
  #cardlinkForm
  class="checkout mx-2"
  [hidden]="true"
>
  <input
    type="hidden"
    name="version"
    value="{{ requestJSON?.paymentFormParams?.version || '2' }}"
  />
  <input
    type="hidden"
    name="mid"
    value="{{ requestJSON?.paymentFormParams?.mid }}"
  />
  <input
    type="hidden"
    name="lang"
    value="{{ requestJSON?.paymentFormParams?.lang || 'en' }}"
  />
  <input
    type="hidden"
    name="deviceCategory"
    value="{{ requestJSON?.paymentFormParams?.deviceCategory || '0' }}"
  />
  <input
    type="hidden"
    name="orderid"
    value="{{ requestJSON?.paymentFormParams?.orderid }}"
  />
  <input
    type="hidden"
    name="orderDesc"
    value="{{ requestJSON?.paymentFormParams?.orderDesc }}"
  />
  <input
    type="hidden"
    name="orderAmount"
    value="{{ requestJSON?.paymentFormParams?.orderAmount }}"
  />
  <input
    type="hidden"
    name="currency"
    value="{{ requestJSON?.paymentFormParams?.currency || 'EUR' }}"
  />
  <input
    type="hidden"
    name="payerEmail"
    value="{{ requestJSON?.paymentFormParams?.payerEmail }}"
  />
  <input
    type="hidden"
    name="payerPhone"
    value="{{ requestJSON?.paymentFormParams?.payerPhone }}"
  />
  <input
    type="hidden"
    name="billCountry"
    value="{{ requestJSON?.paymentFormParams?.billCountry }}"
  />
  <input
    type="hidden"
    name="billZip"
    value="{{ requestJSON?.paymentFormParams?.billZip }}"
  />
  <input
    type="hidden"
    name="billCity"
    value="{{ requestJSON?.paymentFormParams?.billCity }}"
  />
  <input
    type="hidden"
    name="billAddress"
    value="{{ requestJSON?.paymentFormParams?.billAddress }}"
  />
  <input
    type="hidden"
    name="confirmUrl"
    value="{{ requestJSON?.paymentFormParams?.confirmUrl }}"
  />
  <input
    type="hidden"
    name="cancelUrl"
    value="{{ requestJSON?.paymentFormParams?.cancelUrl }}"
  />
  <input
    type="hidden"
    name="digest"
    value="{{ requestJSON?.paymentFormParams?.digest }}"
  />
</form>
